export class AppConfig {
  primaryColor: string = '#00a5b2'
  accentColor: string = '#b2004c'
  primaryLightColor: string

  buttonColor: string
  buttonHoverColor: string
  buttonTextColor: string = '#ffffff';

  buttonAltColor: string
  buttonAltHoverColor: string
  buttonAltTextColor: string = '#ffffff';

  linkColor = '#0068a5'
  headerColor: string = '#000000';
}



